import { handleHttpError } from '../../http/errorHandler';
import * as summernoteClient from './summernoteClient';

// summernote の onImageUpload から呼ぶ。summernote は貼り付け・ドロップ・ダイアログのいずれでも 1 件以上のファイルを渡す
export function insertUploadedImage(note: JQuery, files: Blob[]): void {
  summernoteClient
    .create(files[0])
    .then(uploaded => {
      note.summernote('insertImage', uploaded.url);
    })
    .catch((error: unknown) => {
      handleHttpError(error);
    });
}
